'use client';

import { Box, LoadingSpinner } from '@goodneighbor/ui';
import { concatWithEllipsis } from '@/services/string/formatters';
import styles from './partnerPreviewCard.module.scss';

export type PartnerPreviewCardProps = {
  name?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  isLoading?: boolean;
};

export default function PartnerPreviewCard({
  name,
  description,
  imageUrl,
  isLoading = false
}: PartnerPreviewCardProps) {
  const displayName = name?.trim();
  const trimmedDescription = description?.trim();
  const avatarSrc = imageUrl?.trim() || '/placeholder/avatar.png';

  if (isLoading) {
    return (
      <Box className={styles.card} radius="md" padding="sm">
        <div className={styles.loadingContainer}>
          <LoadingSpinner />
        </div>
      </Box>
    );
  }

  return (
    <Box className={styles.card} radius="md" padding="xs">
      <div className={styles.avatar}>
        <img
          src={avatarSrc}
          alt={displayName ? `${displayName} avatar` : 'Organization avatar'}
          className={styles.avatarImage}
        />
      </div>

      <div className={styles.info}>
        {displayName && <span className={styles.name}>{displayName}</span>}
        {trimmedDescription && (
          <span className={styles.descriptionText}>
            {concatWithEllipsis(trimmedDescription)}
            <span className={styles.learnMore}>Learn more</span>
          </span>
        )}
      </div>
    </Box>
  );
}
